import Vue from 'vue'
import axios from 'axios'
import Mint from 'mint-ui'
import App from './App.vue'
import router from './router'

import api from './api'
import 'mint-ui/lib/style.css'
import '../static/css/style.min.css'
import '../static/css/reset.css'
import '../static/js/rem.js'
import "swiper/dist/css/swiper.min.css"
import VueWechatTitle from 'vue-wechat-title'//添加动态title
import { Loadmore } from 'mint-ui';



Vue.use(Mint);
Vue.use(router);
Vue.use(VueWechatTitle);
Vue.prototype.$api=api;
Vue.prototype.$ajax=axios;
Vue.prototype.bus=new Vue;

Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{//添加动态title
  // if (to.meta.title) {
  //   document.title=to.meta.title
  // }
  // next()
  let title = to.meta.title
  if(title) {
      document.title = title
      // 下面是关键的地方，匹配苹果设备
      if(/ip(hone|od|ad)/i.test(navigator.userAgent)) {
          let i = document.createElement('iframe')
          i.src = "//m.baidu.com/favicon.ico" // src要设置成一个实际存在的图片，最好是比较小的，如果不存在，在使用this.$router.go(-1)这种跳转时，会出现错误
          i.style.display = "none"
          i.onload = () => {
              setTimeout(() => {
                  document.body.removeChild(i)
              },0)
          }
      }
  }
  next()
})
// router.afterEach(route => {
//   // 从路由的元信息中获取 title 属性
//   if (route.meta.title) {
//       document.title = route.meta.title;
//       // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
//       if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
//           const hackIframe = document.createElement('iframe');
//           hackIframe.style.display = 'none';
//           hackIframe.src = '../../static/html/fixIosTitle.html?r=' + Math.random();
//           document.body.appendChild(hackIframe);
//           setTimeout(_ => {
//               document.body.removeChild(hackIframe)
//           }, 300)
//       }
//   }
// })


new Vue({
  router,
  // store,
  render: h => h(App),

}).$mount('#app')
